import { CompaniesGridWebComponent } from './component/CompaniesGridWebComponent';
import { WEB_COMPONENT_COMPANIES_GRID } from '../../webcomponents.constants';

export { CompaniesGridWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANIES_GRID, CompaniesGridWebComponent);
